import {
  MediaDeviceMenu,
  TrackToggle,
  usePersistentUserChoices,
} from "@livekit/components-react";
import { ReactNode, useEffect } from "react";
import { useAudioDeviceId, useAudioEnabled } from "../../hooks/media";
import { LocalAudioTrack, Track } from "livekit-client";
import { FiMic, FiMicOff } from "react-icons/fi";
import { useLogEvent } from "../../hooks/log";

export default function MicToggle(props: {
  track?: LocalAudioTrack;
  initialState?: boolean;
  toggle?: ReactNode;
  onChange?: (enabled: boolean, isUserInitiated: boolean) => void;
  className?: string;
}) {
  const { saveAudioInputDeviceId } = usePersistentUserChoices();

  // Initialize device settings
  const [audioEnabled, setAudioEnabled] = useAudioEnabled();
  const [audioDeviceId, setAudioDeviceId] = useAudioDeviceId();

  // Save to local storage
  useEffect(() => {
    saveAudioInputDeviceId(audioDeviceId);
  }, [audioDeviceId, saveAudioInputDeviceId]);

  const logEvent = useLogEvent();

  return (
    <>
      <TrackToggle
        className={props.className}
        initialState={props.initialState}
        source={Track.Source.Microphone}
        onChange={(enabled, isUserInitiated) => {
          if (isUserInitiated) {
            logEvent({
              type: "toggle_mic",
              details: { enabled: enabled },
            });
          }
          props.onChange && props.onChange(enabled, isUserInitiated);
          setAudioEnabled(enabled);
          // Don't save enabled to local storage, bug causing problems
          // if (isUserInitiated) {
          //   saveAudioInputEnabled(enabled);
          // }
        }}
        showIcon={false}
      >
        {props.toggle || (audioEnabled ? <FiMic /> : <FiMicOff />)}
      </TrackToggle>

      {/* Hack: Need to include device menu in same component as track toggle */}
      {props.track && (
        <div style={{ display: "none" }}>
          <MediaDeviceMenu
            initialSelection={audioDeviceId}
            kind="audioinput"
            tracks={{ audioinput: props.track }}
            onActiveDeviceChange={(_, id) => setAudioDeviceId(id)}
          >
            Microphone
          </MediaDeviceMenu>
        </div>
      )}
    </>
  );
}
